import { ENDPOINTS } from "../../utils/endPoints";
import { GET_API_CALL, PATCH_API_CALL } from "../../utils/services";
import {
  UPDATE_USERS_LIST_DATA,
  UPDATE_USERS_LOADING,
} from "../../store/actionTypes";
import { createParams } from "../../utils/commonFunctions";
import toast from "react-hot-toast";

/**
 * @description all actions related to users
 * @returns response of Users api
 */
export const getAllUsers = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_USERS_LOADING });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().UserReducer;
    const params = createParams({
      searchKey,
      pageNo,
      limit,
      sortOrder,
      sortBy,
    });
    GET_API_CALL(ENDPOINTS.USERS.GET_ALL_USERS, params, (response) => {
      console.log("Users List Response :", response);
      if (response?.isSuccess) {
        let { data, total, totalPage } = response?.data;
        dispatch({
          type: UPDATE_USERS_LIST_DATA,
          payload: {
            total,
            totalPage,
            usersList: [...data],
          },
        });
      }
      dispatch({ type: UPDATE_USERS_LOADING });
    });
  };
};

export const getUserDetail = (param, callback) => {
  return () => {
    GET_API_CALL(ENDPOINTS.USERS.USER_DETAIL, param, (response) => {
      console.log("User Detail Response :", response);
      if (response.isSuccess) {
        callback(response.data?.data);
      } else callback({});
    });
  };
};

export const block_unblock_user = (data, params, callback) => {
  return () => {
    PATCH_API_CALL(
      ENDPOINTS.USERS.BLOCK_UNBLOCK_USER + params,
      data,
      (response) => {
        console.log("Block Unblock Response :", response);
        if (response.isSuccess) {
          callback(response);
          toast.success(response.data?.message);
        } else {
          callback(response);
        }
      }
    );
  };
};
